import { render } from "./PortfolioComp.vue?vue&type=template&id=3300d89a"
import script from "./PortfolioComp.vue?vue&type=script&lang=js"
export * from "./PortfolioComp.vue?vue&type=script&lang=js"

import "./PortfolioComp.vue?vue&type=style&index=0&id=3300d89a&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\compro.rimba.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__